import { DataBean } from "../DataBean";

export class FactoryByyear extends DataBean {


    public async getDocumentFactoryByYear(year:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getDocumentFactoryByYear_Number", [year]);
    }


}